export default {
	baseURL: process.env.NODE_ENV === 'development'
		? 'http://localhost:3000/api'  // 开发环境
		: '/api'  // 生产环境：通过 nginx 代理到 localhost:3000
}
